import { useTheme } from '@material-ui/core/styles';

import iconDark from './logo/aura-portal-icon-dark.svg';
import iconLight from './logo/aura-portal-icon-light.svg';
import logoDark from './logo/aura-portal-logo-dark.svg';
import logoLight from './logo/aura-portal-logo-light.svg';

const DISPLAY_HEIGHT = 52; // matches the height of the nav icons
const COLLAPSED_ICON_HEIGHT = 36;
// Heights inside the SVG files, in SVG units. Both files are cropped to the drawing.
const LOGO_SVG_HEIGHT = 53.491;
const ICON_SVG_HEIGHT = 64;
// Expanded (full) logo looks more centered if moved 2px left
const EXPANDED_OFFSET_X = -2;

const ASSETS = {
  light: { full: logoLight, icon: iconLight },
  dark: { full: logoDark, icon: iconDark },
};

export const Logo = ({ isOpen }: { isOpen: boolean }) => {
  const theme = useTheme();
  const tone = theme.palette.type === 'dark' ? 'dark' : 'light';
  const asset = ASSETS[tone];
  const height = isOpen
    ? (LOGO_SVG_HEIGHT * DISPLAY_HEIGHT) / ICON_SVG_HEIGHT
    : COLLAPSED_ICON_HEIGHT;

  return (
    <img
      style={{
        height,
        width: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        transform: isOpen ? `translateX(${EXPANDED_OFFSET_X}px)` : undefined,
      }}
      src={isOpen ? asset.full : asset.icon}
      alt="Aura Portal"
    />
  );
};
